import { useCallback } from "react";
import { parseQuotaError } from "@/lib/freemium";
import { useUpgrade } from "./premium-lock";

/**
 * Turns a server LIMIT_REACHED denial into the existing upgrade modal.
 * Premium users never hit this path — the server only throws for free plans.
 */
export function useQuotaUpgrade() {
  const { openUpgrade } = useUpgrade();
  return useCallback(
    (error: unknown): boolean => {
      const quota = parseQuotaError(error);
      if (!quota) return false;
      openUpgrade(quota.message);
      return true;
    },
    [openUpgrade],
  );
}
